
import { createContext, useContext, useState } from "react";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const [activeSection, setActiveSection] = useState(
    localStorage.getItem("activeSection") || "Orders"
  );

  const changeSection = (section) => {
    setActiveSection(section);
    localStorage.setItem("activeSection", section);
  };

  return (
    <PageContext.Provider value={{ activeSection, changeSection }}>
      {children}
    </PageContext.Provider>
  );
};

export const usePage = () => useContext(PageContext);
